/**
 * 특수건강진단 기본정보(HEA_BASIC_02) 컬럼 정의
 * HEA_BASIC_02 화면 전용 컬럼 정의
 */

import { CreateColumn } from '../../../../Services/agGrid/createColumn';
import dayjs from 'dayjs';
import { FormControlLabel, Checkbox } from '@mui/material';

/**
 * 특수건강진단 기본정보 컬럼 정의 생성
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    // 체크박스 컬럼 (NO 컬럼)
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow1,
        RestoreRow: props.RestoreRow1,
        gridRef: props.gridRef1,
        rowData: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef1,
        lastCheckedIndexRef: props.lastCheckedIndexRef1,
        handleRowSelection: props.handleRowSelection1,
      },
      maxWidth: 100,
    }),
    // 배치전/특수 컬럼 (필수, select)
    CreateColumn(
      'checkType',
      '배치전/특수',
      'center',
      130,
      true,
      true,
      false,
      'select',
      {
        selectOptions: ['배치전', '특수'],
        valueFormatter: (params) => {
          if (!params.value && params.value !== 0 && params.value !== '0')
            return '';
          // 저장된 값을 배치전/특수로 표시
          if (params.value === '0' || params.value === 0) return '배치전';
          if (params.value === '1' || params.value === 1) return '특수';
          // 기존 Y/N 값도 변환
          if (params.value === 'Y' || params.value === true) return '배치전';
          if (params.value === 'N' || params.value === false) return '특수';
          return params.value;
        },
        valueParser: (params) => {
          // 선택된 값에 따라 0/1로 변환하여 저장
          if (!params.newValue) return '';
          if (params.newValue === '배치전') return '0';
          if (params.newValue === '특수') return '1';
          return params.newValue;
        },
        cellClassRules: {
          'required-cell': (params) =>
            !params.value && params.value !== 0 && params.value !== '0',
        },
      }
    ),
    // 본부 컬럼 (편집불가)
    CreateColumn(
      'depNm1',
      '본부',
      'left',
      130,
      false,
      false,
      false,
      'text',
      {
        tooltip: '성명 선택 시 자동 입력됩니다.',
        cellClass: 'none-editable-cell',
      }
    ),
    // 부서 컬럼 (편집불가)
    CreateColumn(
      'depNm2',
      '부서',
      'left',
      130,
      false,
      false,
      false,
      'text',
      {
        tooltip: '성명 선택 시 자동 입력됩니다.',
        cellClass: 'none-editable-cell',
      }
    ),
    // 팀 컬럼 (편집불가)
    CreateColumn('depNm3', '팀', 'left', 130, false, false, false, 'text', {
      tooltip: '성명 선택 시 자동 입력됩니다.',
      cellClass: 'none-editable-cell',
    }),
    // 파트 컬럼 (편집불가)
    CreateColumn('depNm4', '파트', 'left', 130, false, false, false, 'text', {
      tooltip: '성명 선택 시 자동 입력됩니다.',
      cellClass: 'none-editable-cell',
    }),
    // 직책 컬럼 (편집불가)
    CreateColumn(
      'position',
      '직책',
      'left',
      100,
      false,
      false,
      false,
      'text',
      {
        tooltip: '성명 선택 시 자동 입력됩니다.',
        cellClass: 'none-editable-cell',
      }
    ),
    // 사용자ID 컬럼 (숨김)
    CreateColumn('hscId', '사용자ID', 'left', 110, false, false, true, 'text', {
      minWidth: 110,
    }),
    // 성명 컬럼 (필수, requiredButton 타입)
    CreateColumn(
      'name',
      '성명',
      'center',
      130,
      false,
      true,
      false,
      'requiredButton',
      {
        buttonClickHandler: (params) => {
          if (params.data?.newYn === 'Y') {
            props.PopupClickEvent1?.(params);
          }
        },
        buttonEmptyText: '설정하기',
        buttonEmptyTooltip: '성명은 필수입니다.',
        buttonValueTooltip: (params) => {
          const isNew = params.data?.newYn === 'Y';
          return isNew
            ? '재설정 시 클릭하세요.'
            : '저장된 데이터는 수정할 수 없습니다.';
        },
        cellClassRules: {
          'required-cell': (params) => {
            const value = params.value;
            if (typeof value === 'string') {
              return value.trim() === '';
            }
            if (typeof value === 'number') {
              return false;
            }
            return !value;
          },
          'none-editable-cell': (params) => {
            // 편집 불가일 때 none-editable-cell 클래스 적용
            return params.data?.newYn !== 'Y';
          },
        },
      }
    ),
    // 건강관리 구분 컬럼 (필수, select)
    CreateColumn(
      'hscGubun',
      '건강관리 구분',
      'center',
      200,
      true,
      true,
      false,
      'select',
      {
        selectOptions: [
          'A(이상없음)',
          'D1 (직업병 유소견자)',
          'D2(일반질병 유소견자)',
          'C1(직업병 요관찰자)',
          'C2(일반질병 요관찰자)',
          'R(재검)',
        ],
        valueFormatter: (params) => {
          if (!params.value) return '';
          // 저장된 값이 코드만 있는 경우 설명 추가
          const valueMap = {
            A: 'A(이상없음)',
            D1: 'D1 (직업병 유소견자)',
            D2: 'D2(일반질병 유소견자)',
            C1: 'C1(직업병 요관찰자)',
            C2: 'C2(일반질병 요관찰자)',
            R: 'R(재검)',
          };
          return valueMap[params.value] || params.value;
        },
        valueParser: (params) => {
          // 선택된 값에서 코드만 추출
          if (!params.newValue) return 'A'; // 기본값 'A' 반환
          // 'A(이상없음)' 형식에서 'A'만 추출
          if (params.newValue === 'A(이상없음)') return 'A';
          // 다른 값들도 코드만 추출
          const codeMatch = params.newValue.match(/^([ADC12R]+)/);
          return codeMatch ? codeMatch[1] : params.newValue;
        },
        cellClassRules: {
          'required-cell': (params) =>
            !params.value || params.value.toString().trim() === '',
        },
      }
    ),
    // 소음/분진/야간작업/화학물질 취급 작업 체크 컬럼 (필수, 커스텀 렌더러)
    CreateColumn(
      'workEnvironmentType',
      '소음/분진/야간작업/화학물질 취급 작업 체크',
      'center',
      280,
      false,
      true,
      false,
      'text',
      {
        headerComponentParams: {
          required: true,
          template:
            '<div class="ag-header-cell-label"><span style="color: red; margin-right: 4px;">*</span><span>소음/분진/야간작업/<br>화학물질 취급 작업 체크</span></div>',
        },
        cellRenderer: (params) => {
          // workEnvironmentType은 문자열로 처리 (예: "3" 또는 "1,2,3")
          // 0:소음, 1:분진, 2:야간작업, 3:화학물질
          const workEnvironmentType = params.data.workEnvironmentType || '';

          // 문자열에 숫자가 포함되어 있는지 확인하여 체크박스 상태 결정
          const noise = workEnvironmentType.includes('0');
          const dust = workEnvironmentType.includes('1');
          const night = workEnvironmentType.includes('2');
          const chemical = workEnvironmentType.includes('3');

          const handleChange = (typeNumber, checked) => {
            // 현재 체크된 항목들을 배열로 변환
            const currentTypes = workEnvironmentType
              ? workEnvironmentType.toString().split(',').filter(t => t.trim())
              : [];

            let updatedTypes;
            if (checked) {
              // 체크: 해당 숫자가 없으면 추가
              if (!currentTypes.includes(typeNumber)) {
                updatedTypes = [...currentTypes, typeNumber].sort().join(',');
              } else {
                updatedTypes = workEnvironmentType;
              }
            } else {
              // 체크 해제: 해당 숫자 제거
              updatedTypes = currentTypes.filter(t => t !== typeNumber).join(',');
            }

            params.node.setDataValue('workEnvironmentType', updatedTypes);
            params.node.setData({
              ...params.data,
              workEnvironmentType: updatedTypes,
              editYn: 'Y',
            });
            props.setChangedRowData1?.((prev) => {
              const filtered = prev.filter((row) => row.no !== params.data.no);
              return [
                ...filtered,
                {
                  ...params.data,
                  workEnvironmentType: updatedTypes,
                  editYn: 'Y',
                },
              ];
            });
          };

          return (
            <div
              style={{
                display: 'flex',
                gap: '4px',
                alignItems: 'center',
                justifyContent: 'center',
                flexWrap: 'wrap',
                padding: '2px',
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={noise}
                    onChange={(e) => handleChange('0', e.target.checked)}
                    size="small"
                    sx={{
                      padding: '2px',
                      '& .MuiSvgIcon-root': {
                        fontSize: '16px',
                      },
                    }}
                  />
                }
                label={<span style={{ fontSize: '11px' }}>소음</span>}
                labelPlacement="end"
                sx={{
                  margin: 0,
                  marginRight: '2px',
                  '& .MuiFormControlLabel-label': {
                    fontSize: '11px',
                  },
                }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={dust}
                    onChange={(e) => handleChange('1', e.target.checked)}
                    size="small"
                    sx={{
                      padding: '2px',
                      '& .MuiSvgIcon-root': {
                        fontSize: '16px',
                      },
                    }}
                  />
                }
                label={<span style={{ fontSize: '11px' }}>분진</span>}
                labelPlacement="end"
                sx={{
                  margin: 0,
                  marginRight: '2px',
                  '& .MuiFormControlLabel-label': {
                    fontSize: '11px',
                  },
                }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={night}
                    onChange={(e) => handleChange('2', e.target.checked)}
                    size="small"
                    sx={{
                      padding: '2px',
                      '& .MuiSvgIcon-root': {
                        fontSize: '16px',
                      },
                    }}
                  />
                }
                label={<span style={{ fontSize: '11px' }}>야간</span>}
                labelPlacement="end"
                sx={{
                  margin: 0,
                  marginRight: '2px',
                  '& .MuiFormControlLabel-label': {
                    fontSize: '11px',
                  },
                }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chemical}
                    onChange={(e) => handleChange('3', e.target.checked)}
                    size="small"
                    sx={{
                      padding: '2px',
                      '& .MuiSvgIcon-root': {
                        fontSize: '16px',
                      },
                    }}
                  />
                }
                label={<span style={{ fontSize: '11px' }}>화학물질</span>}
                labelPlacement="end"
                sx={{
                  margin: 0,
                  marginRight: '2px',
                  '& .MuiFormControlLabel-label': {
                    fontSize: '11px',
                  },
                }}
              />
            </div>
          );
        },
        cellClassRules: {
          'required-cell': (params) => {
            const workEnvironmentType = params.data.workEnvironmentType || '';
            // 하나도 체크되지 않았으면 필수 에러 표시
            return !workEnvironmentType || workEnvironmentType.trim() === '';
          },
        },
      }
    ),
    // 취급물질 컬럼
    CreateColumn('hcSubstance', '취급물질', 'left', 180, true, false, false, 'text', {
      maxLength: 100,
    }),
    // 배치 후 첫번째 특수건강진단 주기 컬럼
    CreateColumn(
      'hcPost',
      '배치 후 첫번째 특수건강진단 주기',
      'left',
      190,
      true,
      false,
      false,
      'text',
      {
        headerComponentParams: {
          template:
            '<div class="ag-header-cell-label"><span>배치 후<br>첫번째 특수건강진단 주기</span></div>',
        },
        maxLength: 100,
      }
    ),
    // 검진주기 컬럼 (필수, select)
    CreateColumn(
      'hcCycle',
      '검진주기',
      'center',
      110,
      true,
      true,
      false,
      'select',
      {
        selectOptions: ['6달', '12달', '24달', '36달'],
      }
    ),
    // 검진일 컬럼 (필수, date)
    // 검진연도 컬럼 (검진일 기준, 편집불가)
    CreateColumn('hcYear', '검진연도', 'center', 110, false, false, false, 'text', {
      valueGetter: (params) => {
        const hcDate = params.data?.hcDate;
        if (hcDate && dayjs(hcDate).isValid()) return dayjs(hcDate).format('YYYY');
        return params.data?.hcYear || '';
      },
    }),
    CreateColumn('hcDate', '검진일', 'center', 120, true, true, false, 'date', {}),
    // 유효일자 컬럼 (필수, 편집불가)
    CreateColumn(
      'hcEffeDate',
      '유효일자',
      'center',
      120,
      false,
      true,
      false,
      'date',
      {
        tooltip: '검진일과 검진주기로 자동 계산됩니다.',
        cellClass: 'none-editable-cell',
      }
    ),
    // 알람여부 (Y/N) 컬럼 (필수, select)
    CreateColumn(
      'hcAlarmYn',
      '알람여부 (Y/N)',
      'center',
      130,
      true,
      true,
      false,
      'select',
      {
        selectOptions: ['Y', 'N'],
      }
    ),
    // 검진기관 컬럼 (필수, text)
    CreateColumn(
      'hcCheckupCenter',
      '검진기관',
      'left',
      150,
      true,
      true,
      false,
      'text',
      {
        maxLength: 100,
        flex: 1,
      }
    ),
    // 검진표 첨부 컬럼 (필수, fileButton)
    CreateColumn(
      'hcCheckupAttachmentFileName',
      '검진표 첨부',
      'center',
      200,
      false,
      true,
      false,
      'fileButton',
      {
        fileButtonClickHandler: (data, fieldName) => {
          props.PopupFileClickEvent?.(data, 'hcCheckupFile');
        },
      }
    ),
    // 사후관리조치 첨부 컬럼 (필수, fileButton)
    CreateColumn(
      'hcPostcareAttachmentFileName',
      '사후관리조치 첨부',
      'center',
      220,
      false,
      true,
      false,
      'fileButton',
      {
        fileButtonClickHandler: (data, fieldName) => {
          props.PopupFileClickEvent?.(data, 'hcPostcareFile');
        },
        headerComponentParams: {
          required: true,
          template:
            '<div class="ag-header-cell-label"><span style="color: red; margin-right: 4px;">*</span><span>사후관리조치 첨부<br>(청력보존 프로그램,<br>호흡기보호 프로그램 등)</span></div>',
        },
      }
    ),
    // 비고 컬럼
    CreateColumn('hcRemark', '비고', 'left', 200, true, false, false, 'text', {
      maxLength: 200,
      flex: 1,
    }),
    // ALARM_ID 컬럼 (숨김)
    CreateColumn('alarmId', 'ALARM_ID', 'left', 100, false, false, true, 'text', {
      minWidth: 100,
    }),
  ];
};

/**
 * 엑셀 업로드 관련 컬럼 정의
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs2 = () => {
  return [
    CreateColumn('hscId', '사용자ID', 'left', 130, false, false, false, 'text'),
    CreateColumn(
      'hcSubstance',
      '취급물질',
      'left',
      200,
      true,
      false,
      false,
      'text'
    ),
    CreateColumn('hcNoise', '소음작업', 'left', 130, true, false, false, 'text'),
    CreateColumn('hcNight', '야간작업', 'left', 130, true, false, false, 'text'),
    CreateColumn(
      'hcGubun',
      '건강검진(특수,일반)',
      'center',
      150,
      true,
      false,
      false,
      'select',
      {
        selectOptions: ['특수', '일반'],
        cellEditor: 'agSelectCellEditor',
      }
    ),
    CreateColumn(
      'hcCycle',
      '검진주기',
      'center',
      130,
      true,
      false,
      false,
      'select',
      {
        selectOptions: [
          '1달',
          '2달',
          '3달',
          '4달',
          '5달',
          '6달',
          '7달',
          '8달',
          '9달',
          '10달',
          '11달',
          '1년',
        ],
        cellEditor: 'agSelectCellEditor',
      }
    ),
    CreateColumn('hcDate', '검진일', 'center', 130, true, false, false, 'date', {
    }),
    CreateColumn(
      'hcEffeDate',
      '유효일자',
      'center',
      130,
      true,
      false,
      false,
      'date',
      {}
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
  getColumnDefs2,
};

export default columnDefs;
